// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"KtOrderCardDropDown_dropdown__21fir","icon":"KtOrderCardDropDown_icon__2VVZl"};